import AdminReport from './Admin';
import SalesReport from './Sales';
import Reports from './Reports';

export { AdminReport, SalesReport, Reports };



// WEBPACK FOOTER //
// /src/components/Reports/index.js